import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: React.ReactNode;
}
const faqs: FAQItem[] = [{
  question: '¿Cómo accedo al sistema? ¿Me llega algo a mi casa?',
  answer: <>
        Estamos en la era digital y una de las cosas que más nos entusiasma es
        cómo entregamos este programa. Funciona así: ingresás tu información de
        pago en la siguiente página. Después de eso, recibís{' '}
        <strong data-id="element-119">acceso instantáneo a todo el sistema.</strong> Es una plataforma
        de acceso, pero no te preocupes por cuotas mensuales ni nada de eso.{' '}
        <strong data-id="element-120">Pagás una sola vez y es todo.</strong> Sin cargos adicionales,
        sin cargos ocultos, sin letra chica.
      </>
}, {
  question: 'Mi cocina es muy chica. ¿Me va a servir igual?',
  answer: <>
        No necesitás una cocina grande ni electrodomésticos caros para usar el
        sistema. Fue diseñado pensando en{' '}
        <em data-id="element-121">cocinas reales, no en las de un programa de TV.</em> Lo único que
        necesitás es una hornalla, un horno (o incluso sin horno funcionan
        muchas recetas) y un freezer.{' '}
        <strong data-id="element-122">El sistema se adapta a lo que ya tenés.</strong>
      </>
}, {
  question: '¿Hay alguna cuota mensual?',
  answer: <>
        <strong data-id="element-123">NO.</strong> Si aceptás esta oferta ahora, es un{' '}
        <strong data-id="element-124">pago único de $19.999</strong> y tenés acceso de por vida.
      </>
}, {
  question: '¿Por qué tan barato? ¿Cuál es la trampa?',
  answer: <>
        No hay trampa. Estamos en una{' '}
        <strong data-id="element-125">oferta de lanzamiento limitada</strong> y queremos recompensar a
        las personas que actúan rápido. Cuando esta etapa termine, el precio va
        a subir y probablemente pase a un modelo de suscripción mensual. Pero
        para quienes entran ahora, el precio es un{' '}
        <strong data-id="element-126">PAGO ÚNICO de $19.999.</strong>
      </>
}, {
  question: '¿Y si soy nuevo/a en esto y cocino muy mal?',
  answer: <>
        Creo que <strong data-id="element-127">cualquier persona puede usar este sistema.</strong>{' '}
        Tenemos instrucciones ultra-detalladas para principiantes absolutos. Si
        podés cortar una verdura y prender el horno, podés hacer esto. Nuestras
        instrucciones te guían paso a paso. Un paso a la vez.{' '}
        <em data-id="element-128">
          Antes de que te des cuenta, vas a tener el freezer lleno y la semana
          resuelta.
        </em>
      </>
}, {
  question: '¿Sirve para familias con restricciones alimentarias?',
  answer: <>
        ¡Sí! Por eso incluimos el{' '}
        <strong data-id="element-129">Bono #1 — el Manual de Cocina Segura.</strong> Está diseñado
        específicamente para adaptar el sistema a celíacos, diabéticos e
        intolerantes a la lactosa. Cada receta tiene indicaciones claras de
        sustitución.
      </>
}, {
  question: 'No puedo gastar mucho en el supermercado. ¿Me conviene igual?',
  answer: <>
        Si justamente ese es tu caso...{' '}
        <strong data-id="element-130">esto es PERFECTO para vos.</strong> Porque vas a aprender
        exactamente qué comprar, en qué cantidad, y cómo aprovechar cada peso al
        máximo. Nada de compras de impulso, nada de ingredientes que se pudren.
        Comprás lo justo y cocinás lo justo. <em data-id="element-131">Simple y económico.</em>{' '}
        Nuestros usuarios reportan un ahorro de hasta el <strong data-id="element-132">40%</strong>{' '}
        comparado con su gasto anterior.
      </>
}, {
  question: 'Quiero esto, pero quiero asegurarme de que es seguro. ¿Cómo funciona la garantía?',
  answer: <>
        Obviamente, solo deberías dar tu información de pago a empresas en las
        que confiás al 100%. Por eso usamos plataformas de pago seguras y
        reconocidas. Y la{' '}
        <strong data-id="element-133">garantía de 30 días es mi promesa personal.</strong> Si no te
        gusta por cualquier motivo, mandame un email y te devuelvo el monto
        completo en 48 horas o menos.{' '}
        <strong data-id="element-134">Sin preguntas, sin letra chica, sin vueltas.</strong>
      </>
}, {
  question: '¿Por cuánto tiempo tengo acceso?',
  answer: <>
        Tenés <strong data-id="element-135">acceso DE POR VIDA</strong> a todo el sistema. Tu acceso
        nunca expira y podés ingresar en cualquier momento para consultar el
        material. Además, si sumamos actualizaciones o nuevas recetas en el
        futuro, <strong data-id="element-136">las recibís sin costo adicional.</strong>
      </>
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <div className="rounded-2xl overflow-hidden" style={{
    border: '1px solid var(--border-default)'
  }} data-id="element-137">
      {faqs.map((faq, i) => <div key={i} style={{
      borderBottom: i < faqs.length - 1 ? '1px solid var(--border-light)' : 'none'
    }} data-id="element-138">
          <button className="w-full text-left px-4 py-3.5 flex items-start justify-between gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset" style={{
        background: 'transparent',
        fontFamily: 'var(--font-body)'
      }} onClick={() => toggle(i)} aria-expanded={openIndex === i} aria-controls={`faq-answer-${i}`} data-id="element-139">
            <span className="text-sm md:text-base font-semibold leading-snug" style={{
          color: 'var(--text-primary)',
          fontFamily: 'var(--font-body)'
        }} data-id="element-140">
              {faq.question}
            </span>
            <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-colors duration-200 mt-0.5" style={{
          background: openIndex === i ? 'var(--color-primary)' : 'var(--bg-muted)',
          color: openIndex === i ? 'white' : 'var(--text-muted)'
        }} aria-hidden="true" data-id="element-141">
              {openIndex === i ? <MinusIcon className="w-3.5 h-3.5" data-id="element-142" /> : <PlusIcon className="w-3.5 h-3.5" data-id="element-143" />}
            </span>
          </button>
          <div id={`faq-answer-${i}`} className={`faq-answer ${openIndex === i ? 'open' : ''}`} role="region" data-id="element-144">
            <p className="px-4 pb-4 text-sm leading-relaxed m-0" style={{
          fontFamily: 'var(--font-body)',
          color: 'var(--text-secondary)',
          lineHeight: 1.75
        }} data-id="element-145">
              {faq.answer}
            </p>
          </div>
        </div>)}
    </div>;
}